import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [completedSignup, setCompletedSignup] = useState(false);
    const [completedPersonalInfo, setCompletedPersonalInfo] = useState(false);
    const [completedVerification, setCompletedVerification] = useState(false);
    useEffect(() => {
      const fetchUser = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await axios.get('https://api.theonlysale.com/api/validate-token', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
    
                if (response.status === 200) {
                    setUser(response.data.user); // Set user with ID
                } else {
                    setUser(null);
                }
            } catch (error) {
                console.error("Token validation failed:", error.message);
                setUser(null);
            }
        }
    };
    
    
    
        fetchUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser ,     completedSignup, setCompletedSignup,
            completedPersonalInfo, setCompletedPersonalInfo,
            completedVerification, setCompletedVerification }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
